define(['text!./templates/ctrl-group.html'
], (templateStr)=> {
    let inputId = 0;

    return ()=> {
        return {
            require: ['?^form', '?^ngForm'],
            transclude: true,
            scope: {
                label: '@?',
                readonly: '=?',
                model: '=',
                helpTip: '@',
                filterCodes: '='
            },
            template: templateStr,

            controller: ['$scope', ($scope)=> {
                if (!$scope.model) {
                    throw new Error(`Input with label "${$scope.label}" has an undefined model scope value`);
                }

                $scope.pristine = true;
                //once a different value is set on the model then we mark the field as not pristine
                $scope.$watch('model.value', (newValue, oldValue)=> {
                    $scope.pristine = (!$scope.pristine) ? false : newValue === oldValue;
                });
            }],

            link: (scope, element, attrs, ctrls)=> {
                const parentForm = ctrls[0];
                const validityFn = ()=> {
                   // console.log("ELEMENT PRINT ",element,"  ASPECTS = ",scope.model.aspects[0]);
                    return scope.model.aspects.valid;
                };
                const setPristineFn = ()=> {
                    //we need to use this postDigest function here because the
                    //watch on 'model.value' in the controller gets called after
                    //this function is called even though the model was changed first
                    scope.$$postDigest(
                        ()=> {
                            scope.pristine = true;
                            scope.$apply();
                        }
                    );
                };
                if (parentForm) {
                    const removeListenerFn = parentForm.addModelControl(validityFn, setPristineFn);
                    scope.$on('$destroy', removeListenerFn);
                }


                if (!('readonly' in scope) && attrs.readonly === '') {
                    //if readonly attr exists with no value then set it to true
                    scope.readonly = true;
                }
                scope.isVisible = ()=> {
                    return !('visible' in scope.model.aspects) || scope.model.aspects.visible;
                };

                scope.inputId = inputId++;

                scope.showError = ()=> {
                    const formHasBeenSubmitted = (parentForm) ? parentForm.submitted : true;
                    if ((!scope.model.aspects.valid && !scope.pristine) || (!scope.model.aspects.valid && formHasBeenSubmitted)) {
                        return true;
                    }
                };

                element.on('focusin', ()=> {
                    scope.focused = true;
                    scope.$apply();
                    //element.addClass('control-group-focused');
                });
                element.on('focusout', ()=> {
                    scope.focused = false;
                    scope.$apply();
                    //element.removeClass('control-group-focused');
                });
            }
        };
    };
});



/** WEBPACK FOOTER **
 ** ./common/js/src/edge/platform/widgets/basicinputs/CtrlGroupDirective.js
 **/